export const STORE_SETTING = {
  List: '/store-settings',
  Initial: '/store-settings/initial',
  Update: '/store-settings/{store_id}/{code}',
  UpdateMany: '/store-settings',
  connectPayment: '/store-settings/connect-payment-setting',
  InitialProfile: '/store-settings/initial-profile',
};
